import React from 'react'
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Separator from '../separator';

export default class ModalHeader extends React.Component {
  static propTypes = {
    className: PropTypes.string,
  }

  get classNames() {
    const { className } = this.props;
    return classNames('modal-header', {
      [className]: className,
    })
  }

  render() {
    return(
      <div className={this.classNames}>
        <h2 className='primary-color'>
          {this.props.children}
        </h2>
        <Separator center isSmall />
      </div>
    )
  }
}
